////
/// ============================================================================
/// COMPONENT / Search
///
/// Clean URL e effetto Overlay Loney Planet
/// ============================================================================
///
/// @group components
////

export default () => {
    let searchLink = document.querySelector('.js-search-toggle');

    if (!searchLink) {
        return;
    }

    let searchForm;
    let searchOverlay;

    searchLink.addEventListener('click', (event) => {
        event.preventDefault();

        open();
    });

    function open() {
        let tempElement = document.createElement('div');

        tempElement.innerHTML = document.getElementById('js-search-tpl').innerHTML;

        while (tempElement.firstChild) {
            document.body.appendChild(tempElement.firstChild);
        }

        searchForm = document.querySelector('.js-search');
        searchOverlay = document.querySelector('.js-search-overlay');

        // Autofocus on search field
        searchForm.s.focus();

        // Redirect to the right place on form submit
        searchForm.addEventListener('submit', (event) => {
            event.preventDefault();

            redirect();
        });

        // Animation
        searchForm.classList.add('is-visible');
        searchOverlay.classList.add('is-visible');

        // Close by button
        searchForm.querySelector('.js-search-close').addEventListener('click', close);

        // Close by overlay
        searchOverlay.addEventListener('click', close);
    }

    function close() {
        searchForm.classList.remove('is-visible');
        searchOverlay.classList.remove('is-visible');

        setTimeout(function () {
            searchForm.remove();
            searchOverlay.remove();
        }, 400);
    }

    function redirect() {
        let s = encodeURIComponent(searchForm.s.value).replace(/%20/g, '+');
        window.location = searchForm.action + '?s=' + s;
    }
};
